import { useNavigate, useLocation, Link } from "react-router-dom";
import Logo from "@/components/vu/Logo";

const QUICK_LINKS = [
    { l: "Services", h: "#services" },
    { l: "Pricing", h: "#pricing" },
    { l: "Process", h: "#process" },
    { l: "Contact", h: "#contact" },
];

const SOCIAL_LINKS = [
    { l: "Instagram", h: "#" },
    { l: "Facebook", h: "https://www.facebook.com/vusolutionsdev/" },
    { l: "LinkedIn", h: "#" },
    { l: "Google Reviews", h: "#" },
];

const FOOTER_SOCIAL_ICONS = [
    { icon: "instagram", href: "#" },
    { icon: "facebook-f", href: "https://www.facebook.com/vusolutionsdev/" },
    { icon: "linkedin-in", href: "#" },
    { icon: "google", href: "#" },
];

export default function Footer() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLink = (h) => (e) => {
        e.preventDefault();
        if (location.pathname !== "/") {
            navigate(`/${h}`);
            return;
        }
        const el = document.querySelector(h);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <footer data-testid="site-footer" className="relative bg-[#0A1810] text-white pt-16 pb-6 border-t border-[#1F3A2B] overflow-hidden">
            {/* Ornament */}
            <div className="absolute -top-32 left-1/4 w-[500px] h-[400px] blob-lime blur-3xl pointer-events-none opacity-40" />
            <div className="absolute -bottom-24 right-0 w-[400px] h-[300px] blob-coral blur-3xl pointer-events-none opacity-40" />
            <div className="relative max-w-[1180px] mx-auto px-8 grid md:grid-cols-[1.4fr_.8fr_.8fr] gap-10 pb-11 border-b border-[#1F3A2B]">
                <div>
                    <div className="mb-5"><Logo height={60} /></div>
                    <p className="text-[#A6BDB0] text-sm leading-[1.6] max-w-[300px]">Helping local businesses grow through websites, Google presence, ads, and email marketing — on one accountable retainer.</p>
                    <div className="mt-6 flex flex-wrap gap-2">
                        {["No lock-in", "24-hr reply"].map((t) => (
                            <span key={t} className="mono text-[10px] px-2.5 py-1 rounded-full border border-[#1F3A2B] bg-[#152A20] text-[#A6BDB0]">
                                <i className="fa-solid fa-check text-[#DFFF3D] text-[9px] mr-1.5" />{t}
                            </span>
                        ))}
                    </div>
                </div>

                <div>
                    <h5 className="mono text-[11px] text-[#A6BDB0] mb-4 flex items-center gap-1.5"><span className="w-[6px] h-[6px] rounded-full bg-[#DFFF3D]" />QUICK LINKS</h5>
                    <ul>
                        {QUICK_LINKS.map((x) => (
                            <li key={x.h} className="mb-3 text-[14.5px] text-white">
                                <a href={x.h} onClick={handleLink(x.h)} className="vu-link hover:text-[#DFFF3D] transition-colors">{x.l}</a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h5 className="mono text-[11px] text-[#A6BDB0] mb-4 flex items-center gap-1.5"><span className="w-[6px] h-[6px] rounded-full bg-[#DFFF3D]" />FOLLOW US</h5>
                    <ul>
                        {SOCIAL_LINKS.map((x) => (
                            <li key={x.l} className="mb-3 text-[14.5px] text-white">
                                <a href={x.h} target={x.h !== "#" ? "_blank" : undefined} rel={x.h !== "#" ? "noopener noreferrer" : undefined} className="vu-link hover:text-[#DFFF3D] transition-colors">{x.l}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="relative max-w-[1180px] mx-auto px-8 py-6 flex justify-between items-center text-[13px] text-[#A6BDB0] flex-wrap gap-3">
                <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-4">
                    <span>© {new Date().getFullYear()} V &amp; U Solutions. All rights reserved. · In partnership with <a href="https://orbitforceai.com/" target="_blank" rel="noopener noreferrer" className="text-[#DFFF3D] hover:underline">Orbit Force AI</a></span>
                    <span className="flex gap-3">
                        <Link to="/privacy" className="hover:text-[#DFFF3D] transition-colors">Privacy Policy</Link>
                        <Link to="/terms" className="hover:text-[#DFFF3D] transition-colors">Terms of Service</Link>
                    </span>
                </div>
                <div className="flex gap-4">
                    {FOOTER_SOCIAL_ICONS.map(({ icon, href }) => (
                        <a
                            key={icon}
                            href={href}
                            target={href !== "#" ? "_blank" : undefined}
                            rel={href !== "#" ? "noopener noreferrer" : undefined}
                            className="w-9 h-9 rounded-full border border-[#1F3A2B] flex items-center justify-center text-white hover:bg-[#DFFF3D] hover:border-[#DFFF3D] hover:text-[#0E1F16] transition-colors"
                        >
                            <i className={`fa-brands fa-${icon}`} />
                        </a>
                    ))}
                </div>
            </div>
        </footer>
    );
}